// extracted by mini-css-extract-plugin
export default {"edit":"EventBtn_edit__1rM1P","delete":"EventBtn_delete__nHwif"};